<script setup>
import {ref} from "vue";
import {logout} from "@/plugins/users";
import {useRouter} from "vue-router";

let router = useRouter()

const access = ref(localStorage.getItem("access"))
</script>

<template>
  <header v-if="access">
    <nav>
      <v-btn @click="router.push({name: 'Cabinet'})">Личный кабинет</v-btn>
      <div>
        <v-btn class="ml-2" color="blue" @click="logout()">Выйти</v-btn>
      </div>
    </nav>
  </header>
</template>


<style scoped>
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #f2f2f2;
}

</style>